"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateUpdateDeckBody = exports.validateUpdatePresentationDate = exports.validateUpdateSlide = exports.validateUpdateBullet = exports.MaxImageSize = exports.MinImageSize = exports.AllowedImageExtensions = exports.AllowedImageTypes = void 0;
const validation_1 = require("@fmtk/validation");
const nullOptional_1 = require("../validation/nullOptional");
exports.AllowedImageTypes = ['image/png', 'image/jpeg'];
exports.AllowedImageExtensions = ['.png', '.jpg', '.jpeg'];
exports.MinImageSize = 10;
exports.MaxImageSize = 5 * 1024 * 1024; // 5 Mb
exports.validateUpdateBullet = (0, validation_1.properties)({
    id: (0, validation_1.text)(),
    popupImageUrl: (0, validation_1.optional)((0, validation_1.text)(100 * 1024)),
    popupText: (0, validation_1.optional)((0, validation_1.text)()),
    text: (0, validation_1.optional)((0, validation_1.text)()),
    deleted: (0, validation_1.optional)((0, validation_1.bool)()),
});
exports.validateUpdateSlide = (0, validation_1.properties)({
    id: (0, validation_1.text)(),
    bullets: (0, validation_1.array)(exports.validateUpdateBullet),
    name: (0, validation_1.text)(),
    deleted: (0, validation_1.optional)((0, validation_1.bool)()),
});
exports.validateUpdatePresentationDate = (0, validation_1.properties)({
    date: (0, validation_1.text)(),
    dateType: (0, validation_1.integer)(),
    reminderOptIn: (0, validation_1.bool)(),
});
exports.validateUpdateDeckBody = (0, validation_1.properties)({
    deleted: (0, validation_1.optional)((0, validation_1.bool)()),
    name: (0, validation_1.text)(),
    slides: (0, validation_1.array)((0, nullOptional_1.nullOptional)(exports.validateUpdateSlide)),
    presentationsStarted: (0, validation_1.optional)((0, validation_1.integer)()),
    presentationsCompleted: (0, validation_1.optional)((0, validation_1.integer)()),
    rehearsalsStarted: (0, validation_1.optional)((0, validation_1.integer)()),
    rehearsalsCompleted: (0, validation_1.optional)((0, validation_1.integer)()),
    presentationDate: (0, validation_1.optional)(exports.validateUpdatePresentationDate),
});
//# sourceMappingURL=UpdateDeckBody.js.map